export const getFormattedTime = (unixTimeStamp) => new Date(unixTimeStamp).toISOString();

export const convert = (timestamp, isIso = false, showTime = false) => {
    // Months array
    const months_arr = [
        'Jan',
        'Feb',
        'Mar',
        'Apr',
        'May',
        'Jun',
        'Jul',
        'Aug',
        'Sep',
        'Oct',
        'Nov',
        'Dec',
    ];

    // Convert timestamp to milliseconds
    const date = new Date(isIso ? timestamp : timestamp * 1000);

    // Year
    const year = date.getFullYear();

    // Month
    const month = months_arr[date.getMonth()];

    // Day
    const day = date.getDate();

    let hours = date.getHours();
    const minutes = date.getMinutes() < 10 ? `0${date.getMinutes()}` : date.getMinutes();
    const ampm = hours >= 12 ? 'pm' : 'am';
    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'
    const strTime = `${hours}:${minutes} ${ampm}`;

    const convdataTime = `${day} ${month} ${year} ${showTime ? ` at ${strTime}` : ''}`;

    return convdataTime;
};

export function formatDaysAgo(value, locale='') {
    const date = new Date(value);
    const deltaDays = (date.getTime() - Date.now()) / (1000 * 3600 * 24);
    const formatter = new Intl.RelativeTimeFormat(locale);
    return formatter.format(Math.round(deltaDays), 'days');
}

export const timeSince = (date) => {
    const seconds = Math.floor((Number(new Date()) - date) / 1000);
    let interval = seconds / 31536000;

    if (interval > 1) {
        return `${Math.floor(interval)} years ago`;
    }
    interval = seconds / 2592000;
    if (interval > 1) {
        return `${Math.floor(interval)} months ago`;
    }
    interval = seconds / 86400;
    if (interval > 1) {
        return `${Math.floor(interval)} days ago`;
    }
    interval = seconds / 3600;
    if (interval > 1) {
        return `${Math.floor(interval)} hours ago`;
    }
    interval = seconds / 60;
    if (interval > 1) {
        return `${Math.floor(interval)} minutes ago`;
    }
    return `${Math.floor(seconds)} seconds ago`;
};

export const getShortTimeSince = (date) => {
    const time = date.split(' ')[0];

    if (date.includes('min')) {
        return `${time} m`;
    }

    if (date.includes('hour')) {
        return `${time} h`;
    }

    if (date.includes('day')) {
        return `${time} d`;
    }

    if (date.includes('now')) {
        return 'Now';
    }

    return '';
};
